<template>
  <!-- type=1: 样本采集（汇总统计） -->
  <el-table
    v-if="showTable && type === 1"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    :max-height="isPc?(screenHeight-50>600?(screenHeight-50):600):90000"
    style="width:100%;border: 1px solid #dcdfe6;"
    row-key="id"
    lazy
    :load="treePropsLoad"
    :tree-props="{ children: 'children', hasChildren: 'isClick' }"
    :border="!isPc"
  >
    <el-table-column label="序号" :width="isPc?'80':'35'" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.id==0&&!isPc">全国</span>
        <span v-else>{{ scope.row.id | filterId(type) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="常住地" :width="isPc?'':'42'" align="center">
      <template slot-scope="scope">
        <span>
          {{ scope.row.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column :label="`总样本量\n(主+专)`" align="center">
      <el-table-column prop="totalAmount" :label="'合计'" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="totalPercentDesc" label="占比" :min-width="isPc?'':'52'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column prop="yearTargetQuantity" :label="`2026年\n达标值`" :min-width="isPc?'':'55'" align="center">
    </el-table-column>
    <el-table-column prop="yearTargetPercentageCompleteStr" label="实际采集量占比" :min-width="isPc?'86':'55'" align="center">
    </el-table-column>
    <el-table-column label="主问卷样本量" align="center">
      <el-table-column prop="amount" label="小计" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column label="专题问卷样本量" align="center">
      <el-table-column prop="specialAmount" label="小计" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="publicSpecialAmount" label="公众版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="employmentSpecialAmount" label="从业版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
    </el-table-column>
  </el-table>
  <!-- type=2: 主问卷/专题采集量（数量汇总） -->
  <el-table
    v-else-if="showTable && type === 2"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    :max-height="isPc?(screenHeight-50>600?(screenHeight-50):600):90000"
    style="width:100%;border: 1px solid #dcdfe6;"
    row-key="id"
    lazy
    :load="treePropsLoad"
    :tree-props="{ children: 'children', hasChildren: 'isClick' }"
    :border="true"
  >
    <el-table-column label="序号" :width="isPc?'68':'40'" align="center" fixed="left">
      <template slot-scope="scope">
        <span>{{ scope.row.id | filterId(1) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="常住地" min-width="70" align="center" fixed="left">
      <template slot-scope="scope">
        <span>
          {{ scope.row.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="网民答题(主间卷、专题问卷)数量汇总" align="center">
      <el-table-column prop="totalAmount" :label="'总样本量\n(A+B)'" min-width="70" align="center">
      </el-table-column>
      <el-table-column :label="'主问卷量\n(A1+B1)'" prop="amount" min-width="70" align="center">
      </el-table-column>
      <el-table-column :label="'专题问卷量\n(A2)'" prop="specialAmount" min-width="60" align="center">
      </el-table-column>
      <el-table-column :label="'公众网民版\nA'" align="center">
        <el-table-column :label="'主问卷\n小计\nA1'" prop="publicAmount" min-width="60" align="center">
        </el-table-column>
        <el-table-column :label="'专题问卷\nA2'" align="center">
          <el-table-column :label="'专题问卷\n小计\nA2'" prop="publicSpecialAmount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'网络安全法治社会建设\nA21'" prop="publicSpecial1Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'网络诚信建设\nA22'" prop="publicSpecial2Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'遏制惩处网络违法犯罪行为\nA23'" prop="publicSpecial3Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'个人信息保护和数据安全\nA24'" prop="publicSpecial4Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'网络购物权益保护\nA25'" prop="publicSpecial5Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'特殊人群（未成年人、老年人和残障人士等）网络权益保护\nA26'" prop="publicSpecial6Amount" min-width="80" align="center">
          </el-table-column>
          <el-table-column :label="'互联网平台监管与企业自律\nA27'" prop="publicSpecial7Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'数字政府服务与治理能力提升\nA28'" prop="publicSpecial8Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'人工智能安全与治理挑战\nA29'" prop="publicSpecial9Amount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'中国网民权益保护'" prop="publicSpecial10Amount" min-width="60" align="center">
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column :label="'从业人员版\nB'" align="center">
        <el-table-column :label="'主问卷\n小计\nB1'" prop="employmentAmount" min-width="60" align="center">
        </el-table-column>
        <el-table-column :label="'专题问卷\nB2'" align="center">
          <el-table-column :label="'专题问卷\n小计\nB2'" prop="employmentSpecialAmount" min-width="75" align="center">
          </el-table-column>
          <el-table-column :label="'行业治理与企业合规\nB21'" prop="employmentSpecialAAmount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'行业发展与科技创新\nB22'" prop="employmentSpecialBAmount" min-width="60" align="center">
          </el-table-column>
          <el-table-column :label="'新技术挑战与网络安全\nB23'" prop="employmentSpecialCAmount" min-width="60" align="center">
          </el-table-column>
        </el-table-column>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'TesidenceTable',
  props: {
    type: {
      type: Number,
      default: 1
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    showTable: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ''
    },
    tableRef: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    screenHeight: {
      type: Number,
      default: document.body.screenHeight
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  updated() {
  },
  filters: {
    filterId: function (value, type) {
      if(!value) {
        return ' '
      }
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  methods: {
    clickRecommend(row) {
      this.$emit('clickRecommend', row);
    },
    createPlacard(row, type) {
      this.$emit('createPlacard', row, type);
    },
    treePropsLoad(tree, treeNode, resolve) {
      // 模拟异步加载子节点数据
      setTimeout(() => {
        const children = tree.childrenList || [];
        resolve(children);
      }, 500);
    }
  }
};
</script>

<style scoped>

@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/table/TesidenceTable.vue